import React from "react";
import { Switch } from "@/components/ui/switch";
import { HotelServiceStatus } from "@/types/hotelService";
import {
  useActivateHotelService,
  useDeactivateHotelService,
} from "@/hooks/useHotelServices";

const StatusCell = ({
  id,
  hotelId,
  status,
}: {
  id: string;
  hotelId: string;
  status: HotelServiceStatus;
}) => {
  const { mutateAsync: activateMutate, isPending: isLoadingActivation } =
    useActivateHotelService();

  const { mutateAsync: deactivateMutate, isPending: isLoadingDeactivation } =
    useDeactivateHotelService();

  const handleStatusChange = async (id: string, status: HotelServiceStatus) => {
    const action =
      status === HotelServiceStatus.ACTIVE ? activateMutate : deactivateMutate;

    await action({ id, hotelId });
  };

  return (
    <Switch
      className="data-[state=checked]:bg-[var(--royal-glow-2)]"
      disabled={isLoadingActivation || isLoadingDeactivation}
      checked={status === HotelServiceStatus.ACTIVE}
      onClick={(event) => event.stopPropagation()}
      onCheckedChange={(checked: boolean) => {
        handleStatusChange(
          id,
          checked ? HotelServiceStatus.ACTIVE : HotelServiceStatus.INACTIVE,
        );
      }}
    />
  );
};

export default StatusCell;
